import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { apiClient } from "src/services/config/apiClient";
import { API } from "src/services/config/apiConfig";

import { RegisterDemoPayload } from "./NetTypes";

async function registerDemoRequest(payload: RegisterDemoPayload) {
	return await apiClient.post(API.AUTH.DEMO.REGISTER, payload).then((res) => res.data);
}

export function useRegisterDemoRequest() {
	return useMutation<any, AxiosError, RegisterDemoPayload>({
		mutationFn: (payload: RegisterDemoPayload) => registerDemoRequest(payload)
	});
}
